/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getWards } from 'app/entities/ward/ward.reducer';
import { RoomType } from 'app/shared/model/enumerations/room-type.model';
import { createEntity, getEntity, reset, updateEntity } from './room.reducer';

export const RoomUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const wards = useAppSelector(state => state.ward.entities);
  const roomEntity = useAppSelector(state => state.room.entity);
  const loading = useAppSelector(state => state.room.loading);
  const updating = useAppSelector(state => state.room.updating);
  const updateSuccess = useAppSelector(state => state.room.updateSuccess);
  const roomTypeValues = Object.keys(RoomType);

  const handleClose = () => {
    navigate(`/room${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getWards({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.dateClosed !== undefined && typeof values.dateClosed !== 'number') {
      values.dateClosed = Number(values.dateClosed);
    }
    if (values.bedNoStart !== undefined && typeof values.bedNoStart !== 'number') {
      values.bedNoStart = Number(values.bedNoStart);
    }
    if (values.bedNoEnd !== undefined && typeof values.bedNoEnd !== 'number') {
      values.bedNoEnd = Number(values.bedNoEnd);
    }
    if (values.modifiedTime !== undefined && typeof values.modifiedTime !== 'number') {
      values.modifiedTime = Number(values.modifiedTime);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...roomEntity,
      ...values,
      ward: wards.find(it => it.id.toString() === values.ward?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          roomType: 'PRIVATE',
          ...roomEntity,
          ward: roomEntity?.ward?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.room.home.createOrEditLabel" data-cy="RoomCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.room.home.createOrEditLabel">Create or edit a Room</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="room-id"
                  label={translate('tinyMedicRestApp.room.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.room.name')} id="room-name" name="name" data-cy="name" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.roomNumber')}
                id="room-roomNumber"
                name="roomNumber"
                data-cy="roomNumber"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.tempClosed')}
                id="room-tempClosed"
                name="tempClosed"
                data-cy="tempClosed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.dateClosed')}
                id="room-dateClosed"
                name="dateClosed"
                data-cy="dateClosed"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.description')}
                id="room-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.bedNoStart')}
                id="room-bedNoStart"
                name="bedNoStart"
                data-cy="bedNoStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.bedNoEnd')}
                id="room-bedNoEnd"
                name="bedNoEnd"
                data-cy="bedNoEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.bedPrefix')}
                id="room-bedPrefix"
                name="bedPrefix"
                data-cy="bedPrefix"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.modifiedBy')}
                id="room-modifiedBy"
                name="modifiedBy"
                data-cy="modifiedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.modifiedTime')}
                id="room-modifiedTime"
                name="modifiedTime"
                data-cy="modifiedTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.createdBy')}
                id="room-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.microSec')}
                id="room-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.timestampentry')}
                id="room-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.lastupdated')}
                id="room-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.cursor')}
                id="room-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.active')}
                id="room-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.room.roomType')}
                id="room-roomType"
                name="roomType"
                data-cy="roomType"
                type="select"
              >
                {roomTypeValues.map(roomType => (
                  <option value={roomType} key={roomType}>
                    {translate(`tinyMedicRestApp.RoomType.${roomType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField id="room-ward" name="ward" data-cy="ward" label={translate('tinyMedicRestApp.room.ward')} type="select">
                <option value="" key="0" />
                {wards
                  ? wards.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/room" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RoomUpdate;
